import React from 'react';
import StaticPage, { Section, CardGrid } from './StaticPage';

export default function PropertyManagement() {
  return (
    <StaticPage title="Property Management" subtitle="Tools and tips to help landlords manage student accommodation on RentalX.">
      <Section title="Your Landlord Dashboard">
        <p>The RentalX landlord dashboard gives you everything you need to manage your student listings in one place — from publishing new properties to tracking enquiries and managing bookings.</p>
        <CardGrid items={[
          { title: 'Listing Management', desc: 'Create, edit, and deactivate listings instantly. Add photos, set availability, and update pricing.' },
          { title: 'Enquiry Inbox', desc: 'Receive and respond to student enquiries directly through the platform.' },
          { title: 'Booking Calendar', desc: 'See upcoming move-ins, check-outs, and availability at a glance.' },
          { title: 'Earnings Overview', desc: 'Track your rental income, view payment history, and download statements.' },
        ]} />
      </Section>

      <Section title="Best Practices for Student Landlords">
        <ul className="list-disc list-inside space-y-2">
          <li>Keep listings up to date — remove properties that are no longer available</li>
          <li>Respond to student enquiries within 24 hours to improve your response rate badge</li>
          <li>Provide high-quality photos — listings with 5+ photos get 3× more enquiries</li>
          <li>Include all-inclusive pricing or clearly list what's included (utilities, WiFi, etc.)</li>
          <li>Highlight proximity to universities and public transport stops</li>
          <li>Get verified — our verification badge increases booking rates by 40%</li>
        </ul>
      </Section>

      <Section title="Legal Obligations">
        <p>As a landlord in Australia, you must comply with your state's Residential Tenancies Act. Key obligations include:</p>
        <ul className="list-disc list-inside space-y-2 mt-2">
          <li>Providing a written lease / tenancy agreement</li>
          <li>Lodging the bond with the relevant state authority (e.g., RTBA in Victoria)</li>
          <li>Maintaining the property in a reasonably clean and in good repair</li>
          <li>Giving proper notice before entering the property</li>
          <li>Meeting minimum rental standards for the property</li>
        </ul>
      </Section>

      <Section title="Get Started">
        <p>Ready to list your property? <a href="/landlord-dashboard" className="text-[#094f6f] underline font-medium">Go to your Landlord Dashboard</a> or <a href="/register/landlord" className="text-[#094f6f] underline font-medium">create a landlord account</a>.</p>
      </Section>
    </StaticPage>
  );
}
